import useDataBrandFamily from '@/hooks/use-data-brand-family';
import useDataSecondaryBrand from '@/hooks/use-data-secondary-brand';

const useCheckBrand = () => {
	const dataBrandFamily = useDataBrandFamily();
	const dataSecondaryBrand = useDataSecondaryBrand();

	return {
		isRangeRover:
			dataBrandFamily === 'rangerover' || dataSecondaryBrand === 'rrdx',
		isDefender: dataBrandFamily === 'defender',
		isDiscovery: dataBrandFamily === 'discovery',
	};
};

export default useCheckBrand;
